import React from 'react';

const NotFound = (props) => {
    return (
        <div className="NotFound">
            <div className='Container'>
                <h1>Stránka nebyla nalezena</h1>
            </div>
        </div>
    )
};

export default NotFound;